// extracted by mini-css-extract-plugin
module.exports = {"overlay":"AutoSuggestResponsive_overlay__a1328","autoSuggest":"AutoSuggestResponsive_autoSuggest__d2569"};